import { BREAK_ } from "constants"
import styled from "styled-components"

export const Main = styled.div`
  display: grid;
  grid-gap: 8px;
  grid-template-columns: repeat(auto-fit, 450px);
  height: 100%;
  min-height: 500px;
  background:transparent;
  white-space: nowrap;
  overflow: hidden;
  textOverflow: ellipsis;
  border-radius: 16px;
  flex-wrap: wrap;
  background: rgba(65, 88, 74, 0.10);
    ${BREAK_.md_dn} {
      grid-template-columns: repeat(auto-fit, 300px);
      min-height: 388px;
  }
`

export const Item = styled.div`
  width: 100%;
  cursor: pointer;
  height: 100%;
  padding: 0px 1px 0 1px;
  border-radius: 6px;
`